export default __webpack_public_path__ + "static/media/footer-adman-logo.dfb7d562.jpg";